'use client'

import { type ReactNode } from 'react'

import { useBreakpoints } from '@src/utils/breakpoints.util'
import { cn } from '@src/utils/tailwind'

import { textStyleMap } from '../Builder/Text/Text'

export const BannerAlignment = ['left', 'center', 'right'] as const

export const FontStyles = Object.values(textStyleMap)

interface OfferCardsProps {
  children?: ReactNode
  backgroundColor?: string
  featuredLabel?: string
  featuredLabelPadding?: number
  featuredFontStyle?: (typeof FontStyles)[number]
  featuredFontColor?: string
  featuredColor?: string
  featuredBorderWidth?: number
  featuredBannerAlignment?: (typeof BannerAlignment)[number]
}

const cardClasses =
  'flex min-h-[200px] w-full flex-1 flex-col rounded-3xl border border-bodi-gray-butters p-10 self-center'

const featuredCardClasses = 'border-2 relative pt-11'

export const OfferCard = (props: OfferCardsProps) => {
  const { isMobile, isTablet } = useBreakpoints()
  const {
    children,
    backgroundColor = '#FFFFFF',
    featuredColor = '#825BB5',
    featuredLabel,
    featuredLabelPadding = 16,
    featuredFontStyle = 'text-body-md',
    featuredFontColor = 'white',
    featuredBorderWidth = 2,
    featuredBannerAlignment = 'center',
  } = props
  const borderStyles = featuredLabel
    ? {
        borderColor: featuredColor,
        borderWidth: featuredBorderWidth,
      }
    : undefined

  const bannerAlignment = isMobile || isTablet ? 'center' : featuredBannerAlignment
  const baseLabelYPadding =
    isMobile || isTablet
      ? Math.ceil(featuredLabelPadding / 6) - 4
      : Math.ceil(featuredLabelPadding / 6)

  return (
    <div
      className={cn(cardClasses, {
        [featuredCardClasses]: !!featuredLabel,
        'order-first lg:order-0': !!featuredLabel,
      })}
      style={{ ...borderStyles, backgroundColor }}
    >
      {featuredLabel && (
        <span
          className={cn(`absolute top-0 rounded-b-md whitespace-nowrap${featuredFontStyle}`, {
            'left-1/2 -translate-x-1/2': bannerAlignment === 'center',
            'left-10': bannerAlignment === 'left',
            'right-10': bannerAlignment === 'right',
          })}
          style={{
            backgroundColor: featuredColor,
            color: featuredFontColor,
            padding: `${baseLabelYPadding}px ${Math.max(featuredLabelPadding, 4)}px`,
          }}
        >
          {featuredLabel}
        </span>
      )}
      {children}
    </div>
  )
}
